import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import api, { apiErr } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success("Welcome back!");
      navigate(data.user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md card-surface rounded-3xl p-8 glow-emerald">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Coins className="h-7 w-7 text-emerald-400" />
          <span className="text-xl font-extrabold">ERAN <span className="text-emerald-400">USD</span></span>
        </Link>
        <h1 className="text-2xl font-bold mb-1 text-center">Login</h1>
        <p className="text-sm text-slate-400 text-center mb-6">Log in to your account</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-slate-300">Email</Label>
            <Input data-testid="login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white/5 border-slate-700"
              placeholder="you@example.com" />
          </div>
          <div>
            <Label className="text-slate-300">Password</Label>
            <Input data-testid="login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white/5 border-slate-700"
              placeholder="••••••••" />
          </div>
          <div className="text-right -mt-1">
            <Link to="/forgot-password" data-testid="forgot-password-link"
              className="text-xs text-emerald-400 hover:underline">Forgot password?</Link>
          </div>
          <Button data-testid="login-submit-button" type="submit" disabled={loading}
            className="w-full rounded-full bg-emerald-500 hover:bg-emerald-600 text-white h-11">
            {loading ? "Logging in…" : "Login"}
          </Button>
        </form>
        <p className="text-sm text-slate-400 text-center mt-6">
          New here? <Link to="/register" data-testid="to-register-link" className="text-emerald-400 hover:underline">Register</Link>
        </p>
      </div>
    </div>
  );
}
